/**
 * Petit helper de conversion de chiffres en B64
 */
export const Base64 = {
  _Rixits:
  // 0       8       16      24      32      40      48      56     63
  // v       v       v       v       v       v       v       v      v
    '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz+/',
  /**
   * Convertion d'un décimal en base64
   *
   * @param number
   * @returns {string}
   */
  fromNumber: function (number) {
    if (isNaN(Number(number)) || number === null ||
      number === Number.POSITIVE_INFINITY) throw Error('The input is not valid')
    if (number < 0) throw Error('Can\'t represent negative numbers now')

    let rixit // like 'digit', only in some non-decimal radix
    let residual = Math.floor(number)
    let result = ''
    while (true) {
      rixit = residual % 64
      result = this._Rixits.charAt(rixit) + result
      residual = Math.floor(residual / 64)

      if (residual === 0) break
    }
    return result
  },

  /**
   * Convertion d'une base64 en décimal
   *
   * @returns {number}
   * @param rixits
   */
  toNumber: function (rixits) {
    let result = 0
    rixits = rixits.split('')
    for (let e = 0; e < rixits.length; e++) {
      result = (result * 64) + this._Rixits.indexOf(rixits[e])
    }
    return result
  }
}

/**
 * Calcule un id représentant la date actuelle en base64
 * @return {string}
 */
export const timeId = () => {
  return Base64.fromNumber(Date.now())
}

/**
 * Récupère une représentation base64 de la signature (+ légère)
 *
 * @returns {string}
 */
export const toBase64 = (value) => {
  const json = value.map(function (v) {
    const mappedVal = v.map(function (val) {
      return Base64.fromNumber(val)
    })
    return mappedVal.join(':')
  })
  return json.join('-')
}

/**
 * Redessine la signature depuis une représentation base64
 *
 * @param {string} s64
 */
export const fromBase64 = (s64) => {
  if (!s64) return []
  const json = s64.split('-')
  return json.map(function (v) {
    const mappedVal = v.split(':')
    return mappedVal.map(function (val) {
      return Base64.toNumber(val)
    })
  })
}
